/** Shared Three.js handles (replaces webpack-era `global.*`). */
export const app = {
  camera: null,
  scene: null,
  renderer: null,
  canvas: null,
  displayMesh: null,
  renderTargets: null,
};
